var map = {
	"./LoginLogo.png": 4155,
	"./LoginLogoDashboard.png": 8111,
	"./LoginPicture.png": 7878,
	"./bg.png": 516,
	"./defaultAvatar.png": 9409,
	"./disco-flexible.png": 1595,
	"./editar-texto.png": 6147,
	"./favicon.png": 5069,
	"./orange-logo-small.png": 8333,
	"./papelera-de-reciclaje.png": 6440,
	"./recoverIcon.png": 8746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9775;